import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
`;

export const Main = styled.main`
  display: flex;
`;

export const Section = styled.div`
  width: 100%;
`;
